import { FiltroCobranca } from "core/features/cobranca/typings";
import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import { useCallback, useState } from "react";

export const defaultValuesFiltroCobranca: FiltroCobranca = {
  search: "",
  limit: BaseFiltroPaginate.Limit,
  orderBy: "totalDividas",
  orderDirection: "ASC",
  contasBancariasIds: [],
  unidadesIds: [],
  pessoasIds: [],
};

function useFiltroAgendaCobranca() {
  const [filtro, setFiltro] = useState<FiltroCobranca>(
    defaultValuesFiltroCobranca
  );

  const onChangeFiltro = useCallback((newValues: Partial<FiltroCobranca>) => {
    setFiltro((prev: any) => ({ ...prev, ...newValues }));
  }, []);

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultValuesFiltroCobranca);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroAgendaCobranca;
